"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDownload = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconDownload = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.974 15.938 6.705 10.67l1.529-1.51 2.665 2.666V3.7h2.15v8.125l2.665-2.665 1.53 1.51-5.27 5.268ZM3.7 20.3v-5.17h2.15v3.02h12.3v-3.02h2.15v5.17H3.7Z"
}));
exports.IconDownload = IconDownload;
//# sourceMappingURL=IconDownload.js.map